import { Component, OnInit } from '@angular/core';
import { ReponseCoordonneesCreditService } from '../../services/reponse-coordonnees-credit/reponse-coordonnees-credit.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpStatusCode } from '@angular/common/http';
import { CybermetrieEnum } from '../../models/cybermetrie/cybermetrie.enum';
import { CybermetrieCoordonneesService } from '../../services/cybermetrie/cybermetrie.service';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';

@Component({
  selector: 'app-page-erreur',
  templateUrl: './page-erreur.component.html',
  standalone: false,
})
export class PageErreurComponent implements OnInit {
  titre = '';
  titreTraduit = '';
  status: string = '';
  estErreurSysteme = false;
  codeErreur = '';
  messageErreur = '';
  libelleHandle: string = '';

  constructor(
    private readonly reponseCoordonneesCreditService: ReponseCoordonneesCreditService,
    private readonly translateService: TranslateService,
    private readonly cybermetrieService: CybermetrieCoordonneesService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly gestionTitreService: GestionTitreService,
    router: Router
  ) {
    this.status = router.getCurrentNavigation()?.extras?.state?.status as string;
    this.codeErreur = router.getCurrentNavigation()?.extras?.state?.codeErreur as string;
    this.messageErreur = router.getCurrentNavigation()?.extras?.state?.messageErreur as string;
  }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data) => {
      this.libelleHandle = data.libelleHandle;
      this.titre = this.getTitre();
      this.gestionTitreService.addTitreOnglet(this.getTitreOnglet());
    });
    this.estErreurSysteme = this.status !== HttpStatusCode.ServiceUnavailable.toString();
    this.translateService.get(this.titre).subscribe((texte: string) => (this.titreTraduit = texte));
    const erreurs = new Map<string, string>();
    const texteErreurs: string[] = [this.codeErreur, this.messageErreur];
    erreurs.set(CybermetrieEnum.MESSAGE_ERREUR, texteErreurs.join('|'));
    this.cybermetrieService.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_TRANSACTION,
      CybermetrieEnum.ACTION_ERREUR_TECHNIQUE,
      CybermetrieEnum.LABEL_INFOS_TOTAL,
      null,
      null,
      erreurs
    );
  }

  private getTitre(): string {
    if (this.libelleHandle === 'coordonnees') {
      return 'caad.accueil.titreServiceCarteCredit';
    }
    return this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn()
      ? 'caad.titreMulticarte'
      : 'caad.titre';
  }

  private getTitreOnglet(): string {
    if (this.libelleHandle === 'coordonnees') {
      return 'caad.titreOnglet.page-erreur.coordonnees';
    }
    if (this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn()) {
      return 'caad.titreOnglet.page-erreur.creditMulticarte';
    }
    return 'caad.titreOnglet.page-erreur.credit';
  }
}
